import api from "./axios";

/* ──────────────────────────────────────────
   AUTH
   ────────────────────────────────────────── */
export const authAPI = {
  login: (email, password) =>
    api.post("/login", `email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),

  register: (full_name, email, password) =>
    api.post("/register", `full_name=${encodeURIComponent(full_name)}&email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),

  verifyRegistration: (email, verification_code) =>
    api.post("/email-verify", `email=${encodeURIComponent(email)}&verification_code=${encodeURIComponent(verification_code)}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),

  forgotPassword: (email) =>
    api.post("/forgot-password", `email=${encodeURIComponent(email)}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),

  resetPassword: (verification_code, email, password) =>
    api.post("/reset-password", `verification_code=${encodeURIComponent(verification_code)}&email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),

  socialLogin: (full_name, email, provider, profile_image) =>
    api.post("/social-login", `full_name=${encodeURIComponent(full_name)}&email=${encodeURIComponent(email)}&provider=${encodeURIComponent(provider)}&profile_image=${encodeURIComponent(profile_image || "")}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),

  refreshToken: () => api.get("/relogin"),
  logout: () => api.post("/logout"),
  getUser: () => api.get("/user"),
  updateProfile: (data) => api.put("/user", data),
};

/* ──────────────────────────────────────────
   CONTENT (Movies & TV Shows)
   ────────────────────────────────────────── */
export const contentAPI = {
  // Home page data (sections with movies/shows)
  getHome: () => api.get("/launcher"),

  // Movies launcher (sections by genre)
  getMovies: () => api.get("/movie/launcher"),

  // TV Shows / Series launcher (sections by genre)
  getTvShows: () => api.get("/series/launcher"),

  // Detail page
  getMovieDetail: (id) => api.get(`/movie/${id}/detail`),
  getSeriesDetail: (id) => api.get(`/series/${id}/detail`),
  getDetail: (type, id) =>
    type === "series" || type === "tvshow"
      ? api.get(`/series/${id}/detail`)
      : api.get(`/movie/${id}/detail`),

  // Recommendations
  getRecommendations: (id) => api.get(`/movie/${id}/recommendation`),

  // Seasons & Episodes
  getSeasons: (seriesId) => api.get(`/series/${seriesId}/seasons`),
  getEpisodes: (seasonId) => api.get(`/season/${seasonId}/episodes`),

  // More contents (pagination)
  getMore: (type, title, page, isSeries = false) =>
    api.get(isSeries ? "/series/more" : "/movie/more", { params: { type, title, page } }),

  // Search — matches Android SearchApi
  getTopSearch: () => api.get("/top-search"),
  search: (query) => api.get("/search-result", { params: { search: query } }),

  // Streaming links for playback — returns List<StreamingLink>
  getStreamingLinks: (type, id) => api.get(`/${type}/${id}/streaming-link`),
};

/* ──────────────────────────────────────────
   INTERACTIONS (requires auth)
   ────────────────────────────────────────── */
export const interactionAPI = {
  // Like or dislike — action: "like" or "dislike"
  likeDislike: (id, type, action) =>
    api.post("/like-dislike-event", `id=${id}&type=${type}`, {
      params: { action },
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),

  // Watchlist — action: "add" or "remove"
  watchlistEvent: (id, type, action) =>
    api.get("/watch-list-event", { params: { id, type, action } }),

  // Get user's watchlist
  getWatchlist: () => api.get("/watch-list"),
};

/* ──────────────────────────────────────────
   ADS
   ────────────────────────────────────────── */
export const adsAPI = {
  getAdTags: (type, id) => api.get(`/${type}/${id}/ads`),
};

/* ──────────────────────────────────────────
   FEEDBACK
   ────────────────────────────────────────── */
export const feedbackAPI = {
  submit: (subject, message, email) =>
    api.post("/feedback/store", `subject=${encodeURIComponent(subject)}&message=${encodeURIComponent(message)}&email=${encodeURIComponent(email)}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),
};

/* ──────────────────────────────────────────
   PAGES / POLICIES (public)
   ────────────────────────────────────────── */
export const pagesAPI = {
  getPolicies: () => api.get("/policies"),
};
